__turbopack_context__.v({
  "shimmer": "Skeleton-module__iLQKgG__shimmer",
  "skeleton": "Skeleton-module__iLQKgG__skeleton",
});
